import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { destroy as destroyFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'
import transformProps from 'loankeeper-common/containers/transformProps'
import { translate } from 'loankeeper-common/helpers'
import { LKModalContainer } from 'shared/LKModal'
import { destroy as destroyGrid, getSelectedRow } from 'shared/LKGrid'
// import { Order } from 'WebAPI'

// import withFetcher from '../../shared/containers/withFetcher'
import {
  accEntryCommentView,
  accEntryCommentAdd,
  accEntryCommentEdit,
  accEntryCommentDelete,
  destroyComments,
} from 'src/store/accEntry'
import withFetcherHoc from 'src/features/shared/containers/withFetcherNew'

export default flowRight(
  LKModalContainer('OrderComments'),

  transformProps((props) => ({
    ...props,
    APIParams: {
      OperTypeID: props.OperTypeID || 1,
      action: 'view',
    },
  })),

  //UPDATED API REQUEST acc_entry_comments_api action: view
  withFetcherHoc({
    fetcherName: 'comments',
    APICall: accEntryCommentView,
    getDataFromResponse: () => {},
    renderChild: true,
  }),

  // withFetcher({
  //   fetcherName: 'OrderCommentsList',
  //   APICall: Order.comments,
  //   getDataFromResponse: () => { },
  //   renderChild: true,
  // }),

  connect(
    (state) => {
      return {
        list: { Data: state.comments.data },
        // list: getData('OrderCommentsList')(state),
        selected: getSelectedRow(state, 'OrderAddComments'),
      }
    },

    (dispatch, ownProps) => ({
      destroyGrid: (name) => dispatch(destroyGrid(name)),
      destroyFetcher: (name) => dispatch(destroyFetcher(name)),
      destroyComments: () => dispatch(destroyComments()),
      fetchComments: (filterOn) => {
        // dispatch(
        //   fetchSFM({
        //     instanceName: 'OrderCommentsList',
        //     callApi: Order.comments,
        //     callApiArgs: [{ action: 'view', OperTypeID: filterOn ? undefined : ownProps.OperTypeID || 1 }],
        //   }),
        // )
        //UPDATED API REQUEST acc_entry_comments_api action: view
        dispatch(
          accEntryCommentView({
            OperTypeID: filterOn ? undefined : ownProps.OperTypeID || 1,
          }),
        )
      },
    }),
  ),

  reduxForm({
    form: 'OderComments',

    validate: (values) => {
      const errors = {}
      if (!values.Comment) {
        errors.Comment = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
      }

      return errors
    },

    onSubmit: (values, dispatch, ownProps) => {
      const apiArguments = {
        ...values,
        OperTypeID: ownProps.OperTypeID || 1,
      }

      // if (['edit', 'delete'].includes(values.action)) {
      //   apiArguments.ID = ownProps.selected.ID
      // }

      let action = null

      if (values.action === 'edit') {
        apiArguments.ID = ownProps.selected.ID
        action = accEntryCommentEdit
      } else if (values.action === 'delete') {
        apiArguments.ID = ownProps.selected.ID
        action = accEntryCommentDelete
      } else {
        action = accEntryCommentAdd
      }

      return dispatch(
        // fetchSFM({
        //   fetcherName: 'AddEditOrderComment',
        //   callApi: Order.comments,
        //   callApiArgs: [apiArguments],
        // }),
        //UPDATED API REQUEST acc_entry_comments_api action: add || edit || delete
        action(apiArguments),
      )
        .then(() => {
          // dispatch(
          //   fetchSFM({
          //     instanceName: 'OrderCommentsList',
          //     callApi: Order.comments,
          //     callApiArgs: [{ OperTypeID: ownProps.OperTypeID || 1, action: 'view' }],
          //   }),
          // )
          //UPDATED API REQUEST acc_entry_comments_api action: view
          dispatch(accEntryCommentView({ OperTypeID: ownProps.OperTypeID || 1, action: 'view' }))
        })
        .catch((error) => console.error(error))
    },
  }),
)
